import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/applications/types';

const initialState = Immutable.fromJS({
  isSummaryLoading: false,
  applicationSummary: {},
  error: null,
  isApplicationIntermediateSubstatusUpdating: false,
  isApplicationBatchIntermediateSubstatusUpdating: false,
  isApplicationBatchFinalDecisionUpdating: false,
  batchIntermediateSubstatusOperationData: null,
  batchFinalDecisionOperationData: null,
  isApplicationFinalDecisionUpdating: false,
  isApplicationFinalDecisionCanceling: false
});

export default reducerCreator(initialState, {
  [types.APPLICATION_SET_SUMMARY_LOADING]: (state, { isLoading }) =>
    state.set('isSummaryLoading', isLoading),

  [types.APPLICATION_SET_SUMMARY]: (state, { applicationSummary }) =>
    state.set('applicationSummary', Immutable.fromJS(applicationSummary)),

  [types.APPLICATION_SET_SUMMARY_ERROR]: (state, { error }) => 
    state.set('error', error),

  [types.APPLICATION_RESET_SUMMARY]: () =>
    initialState,

  [types.APPLICATION_SET_COVER_LETTER_LOADING]: (state, { isLoading }) =>
    state.set('isApplicationCoverLetterLoading', isLoading),
  
  [types.APPLICATION_SET_COVER_LETTER]: (state, { applicationCoverLetter }) =>
    state.set('applicationCoverLetter', applicationCoverLetter),

  [types.APPLICATION_SET_SUPPLEMENTARY_QUESTIONS_LOADING]: (state, { isLoading }) =>
    state.set('isApplicationSupplementaryQuestionsLoading', isLoading),
  
  [types.APPLICATION_SET_DOCUMENTS_LOADING]: (state, { isLoading }) =>
    state.set('isApplicationDocumentsLoading', isLoading),

  [types.APPLICATION_SET_SUPPLEMENTARY_QUESTIONS]: (state, { applicationSupplementaryQuestions }) =>
    state.set('applicationSupplementaryQuestions', applicationSupplementaryQuestions),
  
  [types.APPLICATION_SET_DOCUMENTS]: (state, { applicationDocuments }) =>
    state.set('applicationDocuments', applicationDocuments),
  
  [types.APPLICATION_RESET_COVER_LETTER]: (state) => 
    state.set('applicationCoverLetter', null),
  
  [types.APPLICATION_RESET_SUPPLEMENTARY_QUESTIONS]: (state) => 
    state.set('applicationSupplementaryQuestions', null),

  [types.APPLICATION_RESET_DOCUMENTS]: (state) => 
    state.set('applicationDocuments', null),
    
  [types.APPLICATION_SET_INTERMEDIATE_SUBSTATUS_UPDATING]: (state, { isLoading }) =>
    state.set('isApplicationIntermediateSubstatusUpdating', isLoading),
  
  [types.APPLICATION_SET_BATCH_INTERMEDIATE_SUBSTATUS_UPDATING]:  (state, { isLoading }) =>
    state.set('isApplicationBatchIntermediateSubstatusUpdating', isLoading),
    
  [types.APPLICATION_SET_BATCH_INTERMEDIATE_SUBSTATUS_OPERATION_DATA]:  (state, { data }) =>
    state.set('batchIntermediateSubstatusOperationData', data),
  
  [types.APPLICATION_RESET_BATCH_INTERMEDIATE_SUBSTATUS_OPERATION_DATA]: (state) =>
    state.set('batchIntermediateSubstatusOperationData', null),

  [types.APPLICATION_SET_BATCH_FINAL_DECISION_UPDATING]:  (state, { isLoading }) =>
    state.set('isApplicationBatchFinalDecisionUpdating', isLoading),
    
  [types.APPLICATION_SET_BATCH_FINAL_DECISION_OPERATION_DATA]:  (state, { data }) =>
    state.set('batchFinalDecisionOperationData', data),
  
  [types.APPLICATION_RESET_BATCH_FINAL_DECISION_OPERATION_DATA]: (state) =>
    state.set('batchFinalDecisionOperationData', null),
  
  [types.APPLICATION_SET_FINAL_DECISION_UPDATING]: (state, { isLoading }) =>
    state.set('isApplicationFinalDecisionUpdating', isLoading),
  
  [types.APPLICATION_SET_FINAL_DECISION_CANCELING]: (state, { isLoading }) =>
    state.set('isApplicationFinalDecisionCanceling', isLoading)
});



// WEBPACK FOOTER //
// ./src/reducers/applications/application-details.js